import React from 'react'

import { Box, Display, JustifyContent } from '@gousto-internal/citrus-react'

import { deliveryPriceConfig } from 'config/deliveryPrice'

import { SubscriptionTransparencyItem } from './SubscriptionTransparencyItem'

type SubscriptionTransparencyProps = { isDeliveryFree: boolean }

export const SubscriptionTransparency = ({ isDeliveryFree }: SubscriptionTransparencyProps) => (
  <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
    <Box width={['100%', '72%']}>
      <SubscriptionTransparencyItem
        highlightedText="No commitment. No cancellation fees."
        regularText="Skip a box or cancel your subscription online at anytime."
      />
      {isDeliveryFree && (
        <SubscriptionTransparencyItem
          highlightedText="Free delivery on your first box"
          regularText={`(usually ${deliveryPriceConfig.deliveryPriceFormatted}) as a welcome treat.`}
        />
      )}
    </Box>
  </Box>
)
